import React, {
  useEffect, useState, useRef, useCallback,
} from 'react';
import one from '@assets/images/previewStep/1-active.svg';
import two from '@assets/images/previewStep/2-active.svg';
import three from '@assets/images/previewStep/3-active.svg';
import order from '@assets/images/order.svg';
import './index.scss';

const img_step = [one, two, three];

export default (props) => {
  // const update = useUpdate()
  const [list, setList] = useState([]);
  const { startObserver } = props;
  const [curId, setCurId] = useState('');

  const bindObserver = () => {
    const obList = document.querySelectorAll('h2.catalogue-tag,h3.catalogue-tag');
    const formList = Array.from(obList);
    setList(formList);
  };

  useEffect(() => {
    startObserver && bindObserver();
  }, [startObserver]);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1);
      setCurId(hash);
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return (
    <>
      <List list={list} curId={curId} />
    </>
  );
};

const List = ({ list, curId }) => {
  let count = 0;
  return (
    <div className="catalogue">
      <div className="menu">
        <img src={order} alt="" />
        <span className="title">目录</span>
      </div>
      {list.map((item) => {
        const isH2 = item.nodeName === 'H2';
        return (
          <div key={item?.id} className={(item.id === curId ? 'highlight' : '')}>
            {isH2 ? (<span className="m-step-idx"><img src={img_step[count++]} alt="" /></span>) : null}
            <a
              className={(isH2 ? 'headline catalogue-text' : 'subtitle catalogue-text')}
              href={`#${item?.id}`}
            >
              {item.innerText}
            </a>
          </div>
        );
      })}
    </div>
  );
};
